import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom, of} from 'rxjs';
import {catchError, timeout} from 'rxjs/operators';
import {Health} from 'src/app/domain/model/health/health.model';
import {RouteGenerator} from 'src/app/infrastructure/http/route-generator';

@Injectable({
  providedIn: 'root',
})
export default class HealthApi {
  private readonly url = 'health';

  constructor(private http: HttpClient, private routeGenerator: RouteGenerator) {
  }

  public async fetch(): Promise<Health | null> {
    const fullUrl = this.routeGenerator.absoluteUrl(this.url, 'v1');
    return firstValueFrom(
      this.http.get<Health>(fullUrl).pipe(
        timeout(5000),
        catchError(() => of(null))
      )
    );
  }
}
